import { useCallback } from "react";

import { useGetPendingTasks } from "@vega-api/generated/tasks-v1/tasks-v1";
import { type TaskResponse } from "@vega-api/generated/types/taskResponse";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { m } from "@vega-core/paraglide/messages";
import { isFalsy } from "@vega-core/utils/isFalsy";

import { useSubmitTask } from "../../useSubmitTask";

import { TermsAndConditionsViewer } from "./components/TermsAndConditionsViewer";

type Props = {
  onNextStep: VoidFunction;
  task: TaskResponse;
};

export const TermsAndConditionsV2 = ({ onNextStep, task: { type } }: Props) => {
  const { submitTask, isPending } = useSubmitTask();
  const { data: task, isLoading } = useGetPendingTasks(
    { type },
    {
      query: { select: (response) => response[0] },
    },
  );

  const documents = (task?.attributes?.termsAndConditions ?? []).map(
    (document, index) => ({
      id: String(index),
      label: document.header || m.welcome_terms_heading(),
      signedUrl: document.url,
    }),
  );

  const handleAccept = useCallback(() => {
    if (isFalsy(task)) return;

    submitTask(
      {
        taskId: task.id!,
        data: {
          hasAccepted: true,
        },
      },
      {
        onSuccess: () => {
          onNextStep();
        },
      },
    );
  }, [onNextStep, submitTask, task]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <TermsAndConditionsViewer
      documents={documents}
      isAccepting={isPending}
      onAccept={handleAccept}
    />
  );
};
